export default {
  superDesktop: '超级管理面板',
  appNotifications: '应用通知',
  home: '家',
  peopleDirectory: '人',
  peopleList: '列表',
  listDetails: '列表详细信息',
  roles: '角色',
  conversations: '对话',
  conversationMetrics: '对话指标',
  conversationSettings: '对话设置',
  businesses: '企业',
  businessDetails: '业务详情',
  campaigns: '活动',
  newSms: '新短信',
  newCampaign: '新市场活动',
  campaignDetails: '活动详情',
  triggers: '触发器',
  notifications: '通知',
  speechToText: '语音到文本项目',
  authenticator: '身份验证器',
  forms: '形式',
  events: '事件',
  eventDetail: '事件详细信息',
  assistants: '助理',
  promotors: '发起人',
  productsCategories: '产品类别',
  products: '产品',
  places: '地方',
  companyNotFound: '找不到公司',
  upToDateNotifications: '您是最新的通知',
  /* ORDERS */
  clients: '客户',
  colors: '颜色',
  containerTypes: '容器类型',
  purchases: '购买 ',
  purchaseDetail: '采购详情',
  sellers: '卖家',
  suppliers: '供应商',
  /* END ORDERS */
  settings: '设置',
  details: '细节',
  administrators: '管理员',
  billing: '计费',
  payments: '付款',
  creditCards: '信用卡',
  newApp: '新应用程序',
  newCompany: '新公司',
  newPage: '新页面',
  servicesPerPage: '每页服务',
  balance: '平衡',
  loadingTariffs: '装载关税',
  noTariffsOnTheListYet: '列表中尚未包含关税',
  shortenLink: '缩短链接',
  addCreditCart: '添加信用卡',
  addCard: '添加卡片',
  load: '负荷',
  changePassword: '更改密码',
  exit: '退出',
  support: '技术支持',
  /* TOOLBAR CARD */
  services: '服务',
  value: '价值',
  addCreditCard: '添加信用卡',
  createAplication: '建立應用程式'
}
